'use client';

let sharedAudioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;

  try {
    if (!sharedAudioContext) {
      const Ctor = (window.AudioContext || (window as any).webkitAudioContext) as
        | {
            new (): AudioContext;
          }
        | undefined;

      if (!Ctor) return null;

      sharedAudioContext = new Ctor();
    }

    if (sharedAudioContext.state === 'suspended') {
      sharedAudioContext.resume().catch(() => {
        /* ignore resume errors */
      });
    }

    return sharedAudioContext;
  } catch (error) {
    console.warn('Falha ao inicializar AudioContext:', error);
    return null;
  }
}

/** Dois bipes curtos — alerta de que a gravação não chegou a começar. */
export function playRecordingStartFailedAlert() {
  if (typeof window === 'undefined') return;

  const audioContext = getAudioContext();
  if (!audioContext) return;

  try {
    const beep = (start: number, frequency: number) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.type = 'square';
      oscillator.frequency.setValueAtTime(frequency, start);
      gainNode.gain.setValueAtTime(0, start);
      gainNode.gain.linearRampToValueAtTime(0.12, start + 0.02);
      gainNode.gain.linearRampToValueAtTime(0, start + 0.14);
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.start(start);
      oscillator.stop(start + 0.16);
    };

    const now = audioContext.currentTime;
    beep(now, 880);
    beep(now + 0.18, 660);
  } catch (error) {
    console.warn('Não foi possível reproduzir alerta de gravação:', error);
  }
}

export function playToastAlertSound() {
  if (typeof window === 'undefined') return;

  const audioContext = getAudioContext();
  if (!audioContext) return;

  try {
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(720, audioContext.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(480, audioContext.currentTime + 0.18);

    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.25, audioContext.currentTime + 0.02);
    gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.22);

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.25);
  } catch (error) {
    console.warn('Não foi possível reproduzir som de toast:', error);
  }
}
